'use client';

import '@ui5/webcomponents-fiori/dist/ShellBarItem.js';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `ShellBarItem` represents a custom item, that might be added to the `ShellBar`.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/ShellBar" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const ShellBarItem = withWebComponent('ui5-shellbar-item', ['count', 'icon', 'text'], [], [], ['click']);
ShellBarItem.displayName = 'ShellBarItem';
export { ShellBarItem };